import { RastreioCancerPerguntaDbEnum, RastreioCancerPerguntaOpcaoEnum } from 'graphql/types.generated'

import { MamografiaPerguntaField } from '../model-mamografia'

export const tipoMamografiaOptions = [
  { value: RastreioCancerPerguntaOpcaoEnum.DIAGNOSTICO, label: 'Diagnóstica' },
  { value: RastreioCancerPerguntaOpcaoEnum.RASTREAMENTO, label: 'Rastreamento' },
]

export const descargaPapilarOptions = [
  { value: RastreioCancerPerguntaOpcaoEnum.CRISTALINA, label: 'Cristalina' },
  { value: RastreioCancerPerguntaOpcaoEnum.HEMORRAGICA, label: 'Hemorrágica' },
]

export const linfonodoPalpavelOptions = [
  { value: RastreioCancerPerguntaOpcaoEnum.AXILAR, label: 'Axilar' },
  { value: RastreioCancerPerguntaOpcaoEnum.SUPRACLAVICULAR, label: 'Supraclavicular' },
]

export const controleRadioAccordionOptions = [
  {
    label: 'Nódulo',
    name: MamografiaPerguntaField.noduloControleRadio,
  },
  {
    label: 'Microcalcificações',
    name: MamografiaPerguntaField.microcalcificacoesControleRadio,
  },
  {
    label: 'Assimetria focal',
    name: MamografiaPerguntaField.assimetriaFocalControleRadio,
  },
  {
    label: 'Assimetria difusa',
    name: MamografiaPerguntaField.assimetriaDifusaControleRadio,
  },
  {
    label: 'Área densa',
    name: MamografiaPerguntaField.areaDensaControleRadio,
  },
  {
    label: 'Distorção focal',
    name: MamografiaPerguntaField.distorcaoFocalControleRadio,
  },
  {
    label: 'Linfonodo axilar',
    name: MamografiaPerguntaField.linfonodoAxilarControleRadio,
  },
]

export const lesaoCancerAccordionOptions = [
  {
    label: 'Nódulo',
    name: MamografiaPerguntaField.noduloLesaoCancer,
  },
  {
    label: 'Microcalcificações',
    name: MamografiaPerguntaField.microcalcificacoesLesaoCancer,
  },
  {
    label: 'Assimetria focal',
    name: MamografiaPerguntaField.assimetriaFocalLesaoCancer,
  },
  {
    label: 'Assimetria difusa',
    name: MamografiaPerguntaField.assimetriaDifusaLesaoCancer,
  },
  {
    label: 'Área densa',
    name: MamografiaPerguntaField.areaDensaLesaoCancer,
  },
  {
    label: 'Distorção focal',
    name: MamografiaPerguntaField.distorcaoFocalLesaoCancer,
  },
  {
    label: 'Linfonodo axilar',
    name: MamografiaPerguntaField.linfonodoAxilarLesaoCancer,
  },
]

export const avaliacaoRespostaQuimioterapiaOptions = [
  {
    value: RastreioCancerPerguntaOpcaoEnum.MAMA_DIREITA,
    label: 'Mama direita',
  },
  {
    value: RastreioCancerPerguntaOpcaoEnum.MAMA_ESQUERDA,
    label: 'Mama esquerda',
  },
  {
    value: RastreioCancerPerguntaOpcaoEnum.AMBAS,
    label: 'Ambas',
  },
]

export const revisaoMamografiaLesaoAccordionOptions = [
  {
    label: 'Categoria 0',
    name: MamografiaPerguntaField.categoriaZero,
  },
  {
    label: 'Categoria 3',
    name: MamografiaPerguntaField.categoriaTres,
  },
  {
    label: 'Categoria 4',
    name: MamografiaPerguntaField.categoriaQuatro,
  },
  {
    label: 'Categoria 5',
    name: MamografiaPerguntaField.categoriaCinco,
  },
]

export const lesaoBenignaAccordionOptions = [
  {
    label: 'Nódulo',
    name: MamografiaPerguntaField.noduloLesaoBenigna,
  },
  {
    label: 'Microcalcificações',
    name: MamografiaPerguntaField.microcalcificacoesLesaoBenigna,
  },
  {
    label: 'Assimetria focal',
    name: MamografiaPerguntaField.assimetriaFocalLesaoBenigna,
  },
  {
    label: 'Assimetria difusa',
    name: MamografiaPerguntaField.assimetriaDifusaLesaoBenigna,
  },
  {
    label: 'Área densa',
    name: MamografiaPerguntaField.areaDensaLesaoBenigna,
  },
  {
    label: 'Distorção focal',
    name: MamografiaPerguntaField.distorcaoFocalLesaoBenigna,
  },
  {
    label: 'Linfonodo axilar',
    name: MamografiaPerguntaField.linfonodoAxilarLesaoBenigna,
  },
]

const achadosClinicosMamariosFields = [
  MamografiaPerguntaField.lesaoPapilarDireita,
  MamografiaPerguntaField.descargaPapilarDireita,
  MamografiaPerguntaField.noduloLocalizacaoDireita,
  MamografiaPerguntaField.espessamentoLocalizacaoDireita,
  MamografiaPerguntaField.linfonodoPalpavelDireita,
  MamografiaPerguntaField.lesaoPapilarEsquerda,
  MamografiaPerguntaField.descargaPapilarEsquerda,
  MamografiaPerguntaField.noduloLocalizacaoEsquerda,
  MamografiaPerguntaField.espessamentoMamaEsquerda,
  MamografiaPerguntaField.linfonodoPalpavelEsquerda,
]

export const mamografiaDiagnosticaFields = [
  ...achadosClinicosMamariosFields,
  ...controleRadioAccordionOptions.map(({ name }) => name),
  ...lesaoCancerAccordionOptions.map(({ name }) => name),
  MamografiaPerguntaField.avaliacaoRespostaQuimioterapia,
  ...revisaoMamografiaLesaoAccordionOptions.map(({ name }) => name),
  ...lesaoBenignaAccordionOptions.map(({ name }) => name),
]

export const noduloEspessamentoComboboxItems = [
  RastreioCancerPerguntaOpcaoEnum.QSL,
  RastreioCancerPerguntaOpcaoEnum.QIL,
  RastreioCancerPerguntaOpcaoEnum.QSM,
  RastreioCancerPerguntaOpcaoEnum.QIM,
  RastreioCancerPerguntaOpcaoEnum.UQ_LAT,
  RastreioCancerPerguntaOpcaoEnum.UQ_SUP,
  RastreioCancerPerguntaOpcaoEnum.UQ_MED,
  RastreioCancerPerguntaOpcaoEnum.UQ_INF,
  RastreioCancerPerguntaOpcaoEnum.RRA,
  RastreioCancerPerguntaOpcaoEnum.PA,
]

export type PerguntaCellSize = 6 | 12

export interface SectionPergunta {
  name: RastreioCancerPerguntaDbEnum
  label: string
  size?: PerguntaCellSize
}

export const MAMOGRAFIA_PERGUNTAS_INDICACAO_CLINICA: SectionPergunta[] = [
  { name: MamografiaPerguntaField.tipoMamografia, label: 'Tipo de mamografia' },
  { name: MamografiaPerguntaField.mamografiaRastreamento, label: 'Mamografia de rastreamento' },
]

const mamaDireitaPerguntas: SectionPergunta[] = [
  { name: MamografiaPerguntaField.lesaoPapilarDireita, label: 'Lesão papilar', size: 12 },
  { name: MamografiaPerguntaField.descargaPapilarDireita, label: 'Descarga papilar espontânea', size: 12 },
  { name: MamografiaPerguntaField.noduloLocalizacaoDireita, label: 'Nódulo - localização', size: 6 },
  { name: MamografiaPerguntaField.espessamentoLocalizacaoDireita, label: 'Espessamento - localização', size: 6 },
  { name: MamografiaPerguntaField.linfonodoPalpavelDireita, label: 'Linfonodo palpável', size: 12 },
]

const mamaEsquerdaPerguntas: SectionPergunta[] = [
  { name: MamografiaPerguntaField.lesaoPapilarEsquerda, label: 'Lesão papilar', size: 12 },
  { name: MamografiaPerguntaField.descargaPapilarEsquerda, label: 'Descarga papilar espontânea', size: 12 },
  { name: MamografiaPerguntaField.noduloLocalizacaoEsquerda, label: 'Nódulo - localização', size: 6 },
  { name: MamografiaPerguntaField.espessamentoMamaEsquerda, label: 'Espessamento - localização', size: 6 },
  { name: MamografiaPerguntaField.linfonodoPalpavelEsquerda, label: 'Linfonodo palpável', size: 12 },
]

const quimioterapiaPerguntas: SectionPergunta[] = [
  {
    name: MamografiaPerguntaField.avaliacaoRespostaQuimioterapia,
    label: 'Avaliação da resposta de quimioterapia neoadjuvante',
  },
]

export interface MamografiaDiagnosticaSection {
  title: string
  perguntas: SectionPergunta[]
}

export const MAMOGRAFIA_DIAGNOSTICA_SECTIONS: MamografiaDiagnosticaSection[] = [
  { title: 'Mama direita', perguntas: mamaDireitaPerguntas },
  { title: 'Mama esquerda', perguntas: mamaEsquerdaPerguntas },
  { title: 'Controle radiológico Categoria BI RADS 3', perguntas: controleRadioAccordionOptions },
  { title: 'Lesão com diagnóstico de câncer', perguntas: lesaoCancerAccordionOptions },
  { title: 'Avaliação da resposta de quimioterapia neoadjuvante', perguntas: quimioterapiaPerguntas },
  {
    title: 'Revisão de mamografia com lesão, realizada em outra instituição',
    perguntas: revisaoMamografiaLesaoAccordionOptions,
  },
  {
    title: 'Controle de lesão após biopsia de fragmento ou PAAF com resultado benigno',
    perguntas: lesaoBenignaAccordionOptions,
  },
]

export type QuestoesRespondidasMap = Map<RastreioCancerPerguntaDbEnum, string>

export interface PerguntaResposta {
  name: RastreioCancerPerguntaDbEnum
  label: string
  resposta: string
  size: PerguntaCellSize
}
